import Steps from './Steps.component';

export default Steps;